import Modal from '../components/modal';

(function() {

  function successModal() {
    new Modal({
      width: 400,
      header: 'Thanks!',
      text: 'We will be in touch with you soon. In the meantime, take a look at the <a href="/insider">MultiState Insider</a>.'
    })
  }

  function personalEmailModal() {
    new Modal({
      width: 420,
      success: false,
      header: 'Unable to Submit',
      text: 'Thank you for contacting MultiState. Unfortunately, we are unable to respond to personal emails. If you are inquiring regarding our services, please resubmit our form using your professional (e.g., corporate or trade association) email address.',
      error: ''
    })
  }

  function checkForSuccess() {
    if (window.location.href.indexOf('/contact?success=true') >= 0) successModal();
  }

  function checkForBlockReason() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('reason') === 'personal_email') personalEmailModal();
  }

  function checkForModals() {
    checkForSuccess();
    checkForBlockReason();
  }

  function contactTestOnly() {
    const engineering = document.getElementById('engineering')
    engineering.value = 'yes';
  }

  document.addEventListener('turbolinks:load', checkForModals);
  global.contactTestOnly = contactTestOnly;
})()